module.exports = __webpack_public_path__ + "img/jra_logo.40e1cd8f.svg";